import { queryOptions, useQuery } from '@tanstack/react-query';

import { type LiveAppApplication } from '@/types/schema/LiveAppApplication';
import { queryKeys } from '@/hooks/api/queryKeys';
import { axiosInstance as axios } from '@/utils/axiosConfig';

export interface LiveAppInitializationResponse {
  isCustomDomain: boolean;
  application: LiveAppApplication;
}

async function getLiveAppInitialization() {
  const { data: initializationData } = await axios.get<LiveAppInitializationResponse>(
    `/v1/live-app`,
    {
      headers: {
        'knack-live-app-origin-hostname': window.location.hostname,
        'knack-live-app-origin-pathname': window.location.pathname
      },
      withCredentials: true
    }
  );
  return initializationData;
}

export function liveAppInitializationQuery() {
  return queryOptions({
    queryKey: [queryKeys.liveAppInitialization],
    queryFn: getLiveAppInitialization
  });
}

export function liveAppInitializationApplicationQuery() {
  return queryOptions({
    queryKey: [queryKeys.liveAppInitialization],
    queryFn: getLiveAppInitialization,
    select: (data: LiveAppInitializationResponse) => data.application
  });
}

export function useLiveAppInitializationQuery() {
  return useQuery(liveAppInitializationQuery());
}
